import { Ellipsis } from "lucide-react";
import React from "react";

import {
  IgChip,
  IgIconButton,
  IgPaper,
  IgSwitch,
  IgTypography,
} from "@intelligems/ig-theme";
import { WidgetDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { usePutWidget } from "@src/api/widgets/put-widget";
import { useDispatch } from "@src/store";
import { editWidget, updateWidgetAfterPut } from "@src/store/slices/widgets";

interface WidgetPreviewProps {
  widget: WidgetDto;
  library?: boolean;
  children?: React.ReactNode;
}

export const WidgetPreview = ({ widget, children }: WidgetPreviewProps) => {
  const dispatch = useDispatch();
  const { mutate: updateWidget } = usePutWidget(widget.widgetType);
  const isShippingBar = widget.widgetType === "shippingProgressBar";

  const handleEdit = () => {
    dispatch(editWidget(widget));
  };

  const handleSitewideToggle = (checked: boolean) => {
    const updatedWidget = {
      ...widget,
      enabledSitewide: checked,
    };
    dispatch(updateWidgetAfterPut(updatedWidget));
    updateWidget(updatedWidget);
  };

  return (
    <Grid item container xs={12} key={widget.id} sx={{ display: "flex" }}>
      <IgPaper
        sx={{
          width: "100%",
          padding: 4,
        }}
      >
        <Grid item container direction={"column"} height={"100%"}>
          <Grid
            item
            container
            justifyContent={"space-between"}
            alignItems={"center"}
            direction={"row"}
            wrap={"nowrap"}
          >
            {isShippingBar && widget.enabledSitewide ? (
              <Grid item xs={3}>
                <IgSwitch
                  checked={widget.enabledSitewide || false}
                  onChange={(e) => handleSitewideToggle(e.target.checked)}
                  size="small"
                />
              </Grid>
            ) : null}
            <Grid item xs={12}>
              <IgTypography variant={"body1"} fontWeight={400}>
                {widget.name}
              </IgTypography>
            </Grid>
            <Grid
              item
              container
              justifyContent={"flex-end"}
              alignItems={"center"}
            >
              <Grid item>
                <IgIconButton iconSize={16} onClick={handleEdit}>
                  <Ellipsis />
                </IgIconButton>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ flexGrow: 1 }}
          >
            {children}
          </Grid>
        </Grid>
      </IgPaper>
    </Grid>
  );
};
